import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { AppHideForModule } from 'src/app/shared/modules';

import { DiscussionRoutingModule } from './discussion.routing';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DiscussionEffects } from './store/discussion.effects';
import { DiscussionContainerComponent } from './discussion-container/discussion-container.component';
import { DiscussionContainerBSRComponent } from './discussion-container-bsr/discussion-container.component';
import { PostEffects } from 'src/app/shared/ui/post/data/store/effects';
import { postsFeatureKey } from 'src/app/shared/ui/post/data/store/state';
import { postsReducer } from '../../shared/ui/post/data/store/reducer';
import { NewDiscussionComponent } from './new/discussion.new.component';

@NgModule({
  declarations: [
    DiscussionContainerComponent,
    DiscussionContainerBSRComponent,
    NewDiscussionComponent
  ],
  imports: [
    CommonModule,
    AppHideForModule,
    SharedModule,
    DiscussionRoutingModule,
    StoreModule.forFeature(postsFeatureKey, postsReducer),
    EffectsModule.forFeature([DiscussionEffects, PostEffects])
  ]
})
export class DiscussionModule {}
